module.exports = __webpack_public_path__ + "static/assets/8ceb22178d8941261a47eee84e16ed53.png";